import React, { useState } from "react";
import { Helmet } from "react-helmet";
import ActivePage from "../../partials/active-page";
import ApSummary from "./partials/AppointmentSummary";
import { appName } from "../../app.json";
import { NavLink } from "react-router-dom";
import Select from "react-dropdown-select";
import { LIST_STAFF, REASSIGN } from "../../queries/appointment.query";
import { useQuery, useMutation } from "@apollo/react-hooks";
import LoadingSpinner from "../../partials/loading";
import AlertMessage from "../../partials/alertMessage";
import auth from "../../providers/Auth.Provider";

function Reassign({ location, history }) {
	const { item } = location.state;
	const [staffInfo, setStaffInfo] = useState(null);
	const title = "Re-Assign Appointment";
	const pages = [
		{ title: "Appointments", path: "/home/appointment" },
		{ title, path: location.pathname }
	];

	const { GetToken, GetAuthenticatedStaff } = auth.authProvider;

	const { site } = GetToken() && GetAuthenticatedStaff();
	// Staff query
	const { loading, data, error } = useQuery(LIST_STAFF, {
		variables: { site: site && site.id }
	});

	const [
		updateFunc,
		{ loading: ULoading, data: uData, error: uError }
	] = useMutation(REASSIGN);
	return (
		<>
			<Helmet>
				<title>
					{title} | {appName}
				</title>

				<link
					href="../../main/formlayout.css"
					rel="stylesheet"
					type="text/css"
				/>
			</Helmet>
			<ActivePage title={title} pages={pages} />
			<div className="row">
				<ApSummary model={item} />
				<div className="col-md-8 col-xs-12">
					<form
						onSubmit={async event => {
							event.preventDefault();
							//
							await updateFunc({
								variables: {
									id: item.id,
									newStaff: staffInfo.id
								}
							});
						}}
					>
						<div className="card">
							<div className="card-head">
								<header>
									<NavLink
										to={{
											pathname: "/home/appointment/list"
										}}
										title="Back"
										className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
									>
										<i className="material-icons">
											keyboard_backspace
										</i>
									</NavLink>
									Appointment Reassignment
								</header>
							</div>
							<div className="card-body m-b-20">
								<div>
									<LoadingSpinner
										loading={loading || ULoading}
									/>
									<AlertMessage
										message={
											(error && error.message) ||
											(uError && uError.message)
										}
										failed={true}
									/>
									<AlertMessage
										message={
											uData &&
											uData.ReassginAppointment.message
										}
									/>
								</div>
								<form>
									<h5>New Assignee</h5>
									<div className="form-group">
										<Select
											options={
												data &&
												data.GetStaffList.docs
													.filter(i => {
														return (
															i.id !==
															item.assignee.id
														);
													})
													.map(item => ({
														id: item.id,
														display: `${item.surname} ${item.first_name} (${item.email})`
													}))
											}
											className="input-height"
											multi={false}
											valueField="id"
											labelField="display"
											onChange={values =>
												setStaffInfo(values[0])
											}
											searchable={true}
											color="#2bbd7a"
											searchBy="display"
											clearable={true}
											separator={true}
										/>
									</div>
									<div className="form-group text-center m-t-20">
										<button
											type="submit"
											className="mdl-button mdl-button--raised mdl-js-ripple-effect margin-right-10 m-t-20 btn-circle btn-success"
										>
											Update Assignee
											<i className="material-icons">
												keyboard_arrow_down
											</i>
										</button>
										<NavLink
											to={{
												pathname:
													"/home/appointment/list"
											}}
											className="mdl-button mdl-button--raised mdl-js-ripple-effect m-t-20 btn-circle"
										>
											Cancel{" "}
											<i className="material-icons text-danger">
												close
											</i>
										</NavLink>
									</div>
								</form>
							</div>
						</div>
					</form>
				</div>
			</div>
		</>
	);
}

export default Reassign;
